import { createTheme } from "@mui/material/styles";

const headingFontFamily = ["DM Serif Display", "Arial"].join(",");
const bodyFontFamily = ["Museo Sans", "Arial"].join(",");
const theme = createTheme({
  palette: {
    background: {
      default: "#f2f2f2",
    },
    primary: {
      main: "#ff6c0e",
    },
    secondary: {
      main: "#84dade",
    },
    error: {
      main: "#ad5c96",
    },
    warning: {
      main: "#d66d2c",
    },
    info: {
      main: "#a4d3d8",
    },
    success: {
      main: "#235950",
    },
  },
  typography: {
    fontFamily: bodyFontFamily,
    h1: {
      fontFamily: headingFontFamily,
    },
    h2: {
      fontFamily: headingFontFamily,
    },
    h3: {
      fontFamily: headingFontFamily,
    },
    h4: {
      fontFamily: headingFontFamily,
    },
    h5: {
      fontFamily: headingFontFamily,
    },
    h6: {
      fontFamily: headingFontFamily,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        containedPrimary: {
          color: "white",
        },
      },
    },
  },
});

export default theme;
